var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[_c('navTop',{attrs:{"acIndex":4}}),_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.detail)}}),_c('navFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }